
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as edo_mn51BoZan9B9mcDenl2SlvU72nZwnHRtPfgakOQvacMeta } from "/var/www/2025-07-04_11_18/pages/edo.vue?macro=true";
import { default as helpOKFClK6_3nOvNzaRCJbKWJl8R5ozVodln9BpX9yydL0Meta } from "/var/www/2025-07-04_11_18/pages/help.vue?macro=true";
import { default as cargoOKhV54fgPFaJH_45Kw9j7til5Hwumj5a1puyrddiJfu1oMeta } from "/var/www/2025-07-04_11_18/pages/cargo.vue?macro=true";
import { default as indexb8OEhlyq1cuISIzyV2I6IqFcD49fCmFHWhTcFTNyT1UMeta } from "/var/www/2025-07-04_11_18/pages/index.vue?macro=true";
import { default as _91slug_93AoYh9lsPdGppoQwMgCvnRDp06nHz9_sKNBM4oBYR2ZoMeta } from "/var/www/2025-07-04_11_18/pages/[slug].vue?macro=true";
import { default as cookieTiI0C5wxwjXIVtmWnHl0DoJZ5Rvo9RJco8_gn1q5Io4Meta } from "/var/www/2025-07-04_11_18/pages/cookie.vue?macro=true";
import { default as belarussBHcKZAdV_453K3OL0ppfkRoxS3tkmM4kWL1MGTj56rBMMeta } from "/var/www/2025-07-04_11_18/pages/belarus.vue?macro=true";
import { default as bonusesp4S7ByeibGfZeAOFL5JaR67bWrSQYuSxUjZxC1_u7_wMeta } from "/var/www/2025-07-04_11_18/pages/bonuses.vue?macro=true";
import { default as apiqiUivZsY9zHNDTuCZNLOUjjO23i4O4fahLHu6wA3G2AMeta } from "/var/www/2025-07-04_11_18/pages/dev/api.vue?macro=true";
import { default as cmsTXlmMdZrRVy1HXVrnKc3_p4yH_45hEmxWkwxFGeFQNJkUMeta } from "/var/www/2025-07-04_11_18/pages/dev/cms.vue?macro=true";
import { default as konkurszOd3odgLQ65g_45JP0_45xbaqtz2nMhFh2haq5pxdtw_45aNQMeta } from "/var/www/2025-07-04_11_18/pages/konkurs.vue?macro=true";
import { default as successAMlHNPRw4_LjWuBgoCzT7nOdAEKZyYPn830wFZELxq0Meta } from "/var/www/2025-07-04_11_18/pages/success.vue?macro=true";
import { default as tariffsZk2XK_PHGlhGrwu_xmySqKhjbqUI3PpbiCNbUbJa7rwMeta } from "/var/www/2025-07-04_11_18/pages/tariffs.vue?macro=true";
import { default as vacancylyHbHWp11vK0v0JsAPzEu205IFbNMqk6dACcV5tuVBUMeta } from "/var/www/2025-07-04_11_18/pages/vacancy.vue?macro=true";
import { default as contactsAD69pACvfa3ixXcBSQcJMhaK_pWRgWmF6jQfGwkZwokMeta } from "/var/www/2025-07-04_11_18/pages/contacts.vue?macro=true";
import { default as giveawayGTzfQT7T93sGcBenGP8B7k3YwnuORO9G4GXi5vN7jKQMeta } from "/var/www/2025-07-04_11_18/pages/giveaway.vue?macro=true";
import { default as guide_45lkaZ5BQvEJjP9dXRfQgdTUtT7KlyOLO_qyGNdR8HJdZkQMeta } from "/var/www/2025-07-04_11_18/pages/guide-lk.vue?macro=true";
import { default as servicesKw7kMkl_45zJuuNgQ29OTbPIyxMi25QFihB0ls3rwfggEMeta } from "/var/www/2025-07-04_11_18/pages/services.vue?macro=true";
import { default as telegramaTP3v_5FvlZ4z51BncDqqVmn_9B_454GoE_o6p4nSKvLMMeta } from "/var/www/2025-07-04_11_18/pages/telegram.vue?macro=true";
import { default as documentsZCOtVEqFixNKGyCHRIWIM2oPitEy5S9ojvfqF5OQU7IMeta } from "/var/www/2025-07-04_11_18/pages/documents.vue?macro=true";
import { default as franchise4USK5lkH6vulCVgWPuDq8JTuyxPYydM1bScLLfbUOicMeta } from "/var/www/2025-07-04_11_18/pages/franchise.vue?macro=true";
import { default as insurancej1a1R9HIEqNNiqzD5b08ONrcDwCVwwwEfqY5tdk7UQMMeta } from "/var/www/2025-07-04_11_18/pages/insurance.vue?macro=true";
import { default as kirghiziaGvJS0PLblTGSHRkkWKorc0DDjDHQdykt8Zp_45OOpcdOQMeta } from "/var/www/2025-07-04_11_18/pages/kirghizia.vue?macro=true";
import { default as mapSchemeVTMru_45HkqZcHmD0WR946vRVwtdEdQ6piQtkaT9QMbuAMeta } from "/var/www/2025-07-04_11_18/pages/mapScheme.vue?macro=true";
import { default as _91id_93D1ZqaHOub_45UwoLaKQargltyqDsJEQ6oc3ER2OJnafscMeta } from "/var/www/2025-07-04_11_18/pages/news/[id].vue?macro=true";
import { default as return_45sdEu_2t7inrp2iqhc_45svQokfWqeEIfHaDU5bvuGZHtKjEMeta } from "/var/www/2025-07-04_11_18/pages/return-sd.vue?macro=true";
import { default as smsClientt2bWc_45dQiSqGyaK2x1YpaM56POkvf2itgommfYcZ4nQMeta } from "/var/www/2025-07-04_11_18/pages/smsClient.vue?macro=true";
import { default as terminalsuDAem_45tVJgK55LcSUZrHH_U69fzlFl4DjGWQVqXtCJMMeta } from "/var/www/2025-07-04_11_18/pages/terminals.vue?macro=true";
import { default as iframe_dQOrFEBhS_1hpJqJkaVltS6NOIdlyGhiSGgaVnrCtQMeta } from "/var/www/2025-07-04_11_18/pages/dev/iframe.vue?macro=true";
import { default as directionsUhXWneCuTUlPglhV0NghYdglqbL_KJBTWLNdt6iy644Meta } from "/var/www/2025-07-04_11_18/pages/directions.vue?macro=true";
import { default as kazakhstanRzMaWYiYt0_52xaxj7T_45n2M0SKaL1HvaNJp7Pt0cYX8Meta } from "/var/www/2025-07-04_11_18/pages/kazakhstan.vue?macro=true";
import { default as index_mDnGqAQKWHIVySJBnJKFmnRrnQAfgqYCHTdYiCm8SsMeta } from "/var/www/2025-07-04_11_18/pages/news/index.vue?macro=true";
import { default as svgAt91_45VKjilbDGpfz0WgDCLjqJQ5bsX5wyEOtpukd0vQMeta } from "/var/www/2025-07-04_11_18/pages/ui-kit/svg.vue?macro=true";
import { default as vzpay_45failcmT_45Ya38bY_yFvtP_455cxr8hTn3iCHcZG7Rntf_eTvw8Meta } from "/var/www/2025-07-04_11_18/pages/vzpay-fail.vue?macro=true";
import { default as constructor8Cy0YaeSVuKQJaiMEBnVZ9XJS31IrXwh3TaviwgomPkMeta } from "/var/www/2025-07-04_11_18/pages/constructor.vue?macro=true";
import { default as indexx4c68VTtWN_H3hNr07__45DDHu5tnSx5ZnEZRdVbfYMzAMeta } from "/var/www/2025-07-04_11_18/pages/gifts/index.vue?macro=true";
import { default as informationFCQhKAOWnR3kvOoun4zO2wNONh5U2UL3mLVQ2caDBkYMeta } from "/var/www/2025-07-04_11_18/pages/information.vue?macro=true";
import { default as light7yD5wzVJUpLaYScPlbUZ_K2L23mZD4eJ6N0sh60pvA4Meta } from "/var/www/2025-07-04_11_18/pages/order/light.vue?macro=true";
import { default as claim_45filing_I5T5J_45DHALC6UTqUiRYEFRAm3tEK13heb9aguJQbNYMeta } from "/var/www/2025-07-04_11_18/pages/claim-filing.vue?macro=true";
import { default as _91type_935k6Ui9eX2e3WIAGD8UAFe1GFtw2zeDI52V39feW0PJIMeta } from "/var/www/2025-07-04_11_18/pages/gifts/[type].vue?macro=true";
import { default as marketplacesuP5GG5mBqtaZQc0adzS3ufX1JiT_z280pCMtvsLl93AMeta } from "/var/www/2025-07-04_11_18/pages/marketplaces.vue?macro=true";
import { default as networkshopszzBOVYZN47KHJpDcUYe_45jdAoQ1SuZ1FF5e2C6bRO7T4Meta } from "/var/www/2025-07-04_11_18/pages/networkshops.vue?macro=true";
import { default as online_45storehx0XXlJP_UNlptUuR3Wv_45X44N_45lv7b8AqMn148wC2IgMeta } from "/var/www/2025-07-04_11_18/pages/online-store.vue?macro=true";
import { default as managepHAbku9qS_456iK7uXaIkA_dej_B1AEmw6qNkhuTYH1i4Meta } from "/var/www/2025-07-04_11_18/pages/order/manage.vue?macro=true";
import { default as registrationiWP_4zbcDYNKo0N9b4FumhE9gLT_45AZ36QYb7w1_cXWEMeta } from "/var/www/2025-07-04_11_18/pages/registration.vue?macro=true";
import { default as run_45scheduleR_45hxk6TXtzYPMx_453mO_4542r0kkEsf9zVZGynk3CSpEJUMeta } from "/var/www/2025-07-04_11_18/pages/run-schedule.vue?macro=true";
import { default as safe_45custodyHK5Jse_45UuONZ2mYAApky0MPeptuf9rIwza7q7rBFrlEMeta } from "/var/www/2025-07-04_11_18/pages/safe-custody.vue?macro=true";
import { default as image8XwfrByTVRqejrdgPjutQ8E5otRrEIN9Ovv6GfeLfnoMeta } from "/var/www/2025-07-04_11_18/pages/ui-kit/image.vue?macro=true";
import { default as indexo5qd0wxVedtLqMkta4FDS4tS1C_45llrpMD_hdLgpKyDUMeta } from "/var/www/2025-07-04_11_18/pages/ui-kit/index.vue?macro=true";
import { default as baga8LFUTeZzP1xch4MeQ5xw4Z9WAlMO4dYZNKie1U2RTEMeta } from "/var/www/2025-07-04_11_18/pages/wrapping/bag.vue?macro=true";
import { default as boxUxrS9k8M9iLZFxQBSyto6bsl0mvCptyT4Qh_VFlKuQsMeta } from "/var/www/2025-07-04_11_18/pages/wrapping/box.vue?macro=true";
import { default as cargo_45loading3b5YcPGK6MseEo6CO3MxtiQaQSsYlJRqdf5liFGGJSoMeta } from "/var/www/2025-07-04_11_18/pages/cargo-loading.vue?macro=true";
import { default as happybirthdayMkishkQSAxRBMYoINdqrSPhA8pbeeX0ECThsi2nyVt4Meta } from "/var/www/2025-07-04_11_18/pages/happybirthday.vue?macro=true";
import { default as managerLtKngmlYmYWbt6gMbFSRc7hUJpSCGGQU20nSk4aIhwMeta } from "/var/www/2025-07-04_11_18/pages/iframe/manage.vue?macro=true";
import { default as authWXUV4jXHrUTn2F5WxJmYoJGTs4vlIlUtWBplh9kCma8Meta } from "/var/www/2025-07-04_11_18/pages/personal/auth.vue?macro=true";
import { default as publicVfhaN8ull0aiJDXZJjeu_45Gozsag6p6S_Hag7xaK4_2YMeta } from "/var/www/2025-07-04_11_18/pages/ui-kit/public.vue?macro=true";
import { default as already_45answerakFkJbXR0UVU1Fcnzo9TRXE0Y1imfY2hTvbvlaSsbxsMeta } from "/var/www/2025-07-04_11_18/pages/already-answer.vue?macro=true";
import { default as tariffsRouqlfiK8_vCO0cPI4AD66KLIb8TXJ3_o0Lcjexum0wMeta } from "/var/www/2025-07-04_11_18/pages/iframe/tariffs.vue?macro=true";
import { default as _91id_93s8k1bn6cPUUtQzceMpDEr3xAdX3yftW2aUdzNQPhtfMMeta } from "/var/www/2025-07-04_11_18/pages/order/pay/[id].vue?macro=true";
import { default as indexiJwQ9I393hy8OCCGlfbj7IXJcMcWP1K1n77l16mJ8iQMeta } from "/var/www/2025-07-04_11_18/pages/personal/index.vue?macro=true";
import { default as privacy_45policyGKH7X_45k2z_dIIk_45y5kYiIbxtI8apFpMLjykV2PgLZKAMeta } from "/var/www/2025-07-04_11_18/pages/privacy-policy.vue?macro=true";
import { default as _91hash_93mAGhmqN3PzOOrIn4TKNWaab0mfRhxrAwhfQrWt_Wy9oMeta } from "/var/www/2025-07-04_11_18/pages/welcome/[hash].vue?macro=true";
import { default as indexQhMhnwjieEm2foFqVBQuwDKborDElSLef11vxWRx1wEMeta } from "/var/www/2025-07-04_11_18/pages/wrapping/index.vue?macro=true";
import { default as delivery_45russiaPrt3bon8kKB55VlhHHbkXbN4fBr97vHGEmo9tTituz0Meta } from "/var/www/2025-07-04_11_18/pages/delivery-russia.vue?macro=true";
import { default as payment_45methodsPJNVWdgecFJNCKi3LhKXP7dvrH_452koKNoCxOYcLyLjcMeta } from "/var/www/2025-07-04_11_18/pages/payment-methods.vue?macro=true";
import { default as qr_45infox5j_xmHKrEvQqKgsi32BWgsmuWPXDqF_45iiwC_qMFrVUMeta } from "/var/www/2025-07-04_11_18/pages/payment/qr-info.vue?macro=true";
import { default as success9CwEyJCwlOCGln5GOVlE9HvR_45firaAsi1fUN1u_45zeOAMeta } from "/var/www/2025-07-04_11_18/pages/payment/success.vue?macro=true";
import { default as importgIBBy2mPn7Yu9lC1tvCShJWv4MzvgMPu0ZrHoVOeRGEMeta } from "/var/www/2025-07-04_11_18/pages/personal/import.vue?macro=true";
import { default as logoutHVj7CD2qmw_450xvgnLGFkV1avXdR0PgmAXQKSbBrfq1MMeta } from "/var/www/2025-07-04_11_18/pages/personal/logout.vue?macro=true";
import { default as address_45delivery7vHU0FDUppqY4dv6FktFit503u_45iG1CYCeUiMF9ry3UMeta } from "/var/www/2025-07-04_11_18/pages/address-delivery.vue?macro=true";
import { default as cash_45on_45deliveryChSm1vpvEHlrzCRi5jdhE1A1cin_8XIzMJyZ0cLidy4Meta } from "/var/www/2025-07-04_11_18/pages/cash-on-delivery.vue?macro=true";
import { default as happynewyear2024PSbbmhytlyP58D7Hp4HdBeIm0bj8EKFSCB5LOIf9d_45YMeta } from "/var/www/2025-07-04_11_18/pages/happynewyear2024.vue?macro=true";
import { default as ozonNAVyvRDtYdcU07_45kavpy5fWILxysDyfhw3FOi9EMqZkMeta } from "/var/www/2025-07-04_11_18/pages/marketplace/ozon.vue?macro=true";
import { default as pay_45failghLXh6XFRlEitymKxlf0vBMZJv22DrUmA6SFpqx8vZEMeta } from "/var/www/2025-07-04_11_18/pages/payment/pay-fail.vue?macro=true";
import { default as account2Sic2ZEAVHB9hIJfGZVuFks0_45bPB_qpl5pB_45im4emRoMeta } from "/var/www/2025-07-04_11_18/pages/personal/account.vue?macro=true";
import { default as prohibited_45goodsfjIX_45_455d3DhtpOHs2RS5nVv16eAKNd6Dv_vSONDG7UAMeta } from "/var/www/2025-07-04_11_18/pages/prohibited-goods.vue?macro=true";
import { default as directionPJ90XclpgJez1BPlO15if27FZ8G7AxfLEdD5maDyfZMMeta } from "/var/www/2025-07-04_11_18/pages/ui-kit/direction.vue?macro=true";
import { default as free_45group_45pickups7AQE_C3Vn1_uvIeCZp7X9HpfNqdkQEdgEvIoOHzb4oMeta } from "/var/www/2025-07-04_11_18/pages/free-group-pickup.vue?macro=true";
import { default as free_45pickup_45cargoLtskujD7e0wNXaev0VqcXVC1hzuRs8aj5UhIZCwA3uwMeta } from "/var/www/2025-07-04_11_18/pages/free-pickup-cargo.vue?macro=true";
import { default as calculator8VKHzbYVDymSWqwglOI9b53BvEf16MVV_bbqf2WrxYwMeta } from "/var/www/2025-07-04_11_18/pages/iframe/calculator.vue?macro=true";
import { default as merch_45for_45bonuses_PDcYCm56DBM_87VEJ3ZnnJOnySVZIt7sXIE3imTYi8Meta } from "/var/www/2025-07-04_11_18/pages/merch-for-bonuses.vue?macro=true";
import { default as _91id_93A_QOcT3myFpu74YpeH7fbPuQGRSLRZyt_BFDdfuXB0QMeta } from "/var/www/2025-07-04_11_18/pages/order/pay/qr/[id].vue?macro=true";
import { default as card_45info1NAshENdH2bXOWxTHE6oEOo_Xdw3PDb9KIVCyBYRK8AMeta } from "/var/www/2025-07-04_11_18/pages/payment/card-info.vue?macro=true";
import { default as discount4E1KFWeUUB3HQwv33WPKjja_n0mRVOKiIohv4f_45GBWsMeta } from "/var/www/2025-07-04_11_18/pages/personal/discount.vue?macro=true";
import { default as hard_45boxdqnXdDggL7sZJ72xZzqGPYysvNdYqZzSXcG_qQSafBYMeta } from "/var/www/2025-07-04_11_18/pages/wrapping/hard-box.vue?macro=true";
import { default as forwarding_45receiptD4g_457LWSrkrUJWf7VV78SjZHvJ_4587d2aLYN5QdADE0AMeta } from "/var/www/2025-07-04_11_18/pages/forwarding-receipt.vue?macro=true";
import { default as mailClient10201917eNU9ctzojrk7s_VhhD4xdMerMiZiqkssXsbp5tInxc0Meta } from "/var/www/2025-07-04_11_18/pages/mailClient10201917.vue?macro=true";
import { default as mobile_45applicationPdyyD2xicAAVA_45JUQHdFVKKx2Cai0lDJh4RlYN5OAdIMeta } from "/var/www/2025-07-04_11_18/pages/mobile-application.vue?macro=true";
import { default as index9kdZBWI7oHp_45VFGbY4HL592u_qbCS_452XpmyRKekQhyUMeta } from "/var/www/2025-07-04_11_18/pages/order/create/index.vue?macro=true";
import { default as boatS6yrnKJDGQGfMYE1xQHX8AV2IHjPE1mva6s7hY7i1KUMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/boat.vue?macro=true";
import { default as sofadSjmwT2qzO3n5mh_45uW58M6mkR06eCDETka3yJA2kpzgMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/sofa.vue?macro=true";
import { default as cardboardhIuyyZigVv2DN4wLphNSaOcopr9_GXAvz1mlFEYw7p8Meta } from "/var/www/2025-07-04_11_18/pages/wrapping/cardboard.vue?macro=true";
import { default as promocodes9hLOBQ4Jd0sCdXLZM7E0q_45FWjRo8_ksxwl_45Dib4c6YkMeta } from "/var/www/2025-07-04_11_18/pages/personal/promocodes.vue?macro=true";
import { default as benchN4J5qOKKMmGCMphm7ZfmnbtC0MZl_45MU3M4CYodUvZgcMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/bench.vue?macro=true";
import { default as booksRvMuBYp_45kQS_i1ghcXVlls3kG2a0dUs0nuOL_45U3zW0UMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/books.vue?macro=true";
import { default as cableVVS8sodC3SK_HXE5O0wqyHfbEH6G_45wCi0ghF5rAbpOoMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/cable.vue?macro=true";
import { default as chairC9SYeYBdX_45OiK4f6rWZSxHDTOwvB1qpDuTcvpCLv5NUMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/chair.vue?macro=true";
import { default as goodsOCSCad48bLEiy5eKOGMMnJ3lCjJSj8CuruRIMVlKWS0Meta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/goods.vue?macro=true";
import { default as index6EzjXjV_VUyaQkTSEMYVHt_Ul6g0g1_45h9eH4QWu4i_458Meta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/index.vue?macro=true";
import { default as metalm8ZPiHBlvG_ghdNr5URMIXx2Hf3_bizmvVt84mNbTe8Meta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/metal.vue?macro=true";
import { default as pianon3W2y9hP1uf1WsCh5u_45aRa6zuMhK2M_eMet_WDMuEAAMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/piano.vue?macro=true";
import { default as pipestdgCwGAZPvBEChXAKCq_455HkmZKwrw23KTr7nF76Iua0Meta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/pipes.vue?macro=true";
import { default as toolsOXt9BY5QKEB87DCbCH_5k2ytTG0buXPSHVF6K8mA1DIMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/tools.vue?macro=true";
import { default as pallet_45boxZHR0zymbCBbFLxAD3OLMDrscjC4ju0DT5cDpIypO1sAMeta } from "/var/www/2025-07-04_11_18/pages/wrapping/pallet-box.vue?macro=true";
import { default as _91tab_93DBu4jqzATTbQlX18sLmJ0K9UZp_vdQ0roRbl35q6O5EMeta } from "/var/www/2025-07-04_11_18/pages/personal/bonus/[tab].vue?macro=true";
import { default as printw7wz23l0ejBSovoV3KnfHDLYVFLzieoueWP_45yxqIdTQMeta } from "/var/www/2025-07-04_11_18/pages/personal/order/print.vue?macro=true";
import { default as dishesQbXGVpKc900Zd7K_45pDG9gTaQGib_45VWohQ6KeaOjIuCsMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/dishes.vue?macro=true";
import { default as enginee_45ZDrg9pi4MFxrOuvPU8GhschtErQZznkz8BiwgnJ6AMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/engine.vue?macro=true";
import { default as lumberAQWwsLM1ZyOLGQX_w8UHqzisztmYqijpT1dwU9c6t_450Meta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/lumber.vue?macro=true";
import { default as wheelsmmE_ue9qswBXN1aH32RpWrLInjghVe3sU3SXKxLYHtwMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/wheels.vue?macro=true";
import { default as bubble_45filmO2eNOzoalZz3ZAnXfJxYiJMDsqmhukmFKLA_45kqNIh7MMeta } from "/var/www/2025-07-04_11_18/pages/wrapping/bubble-film.vue?macro=true";
import { default as palletisingBNTEPOAe1DnqQ_45oVkKXWuDMVliPizVLYPSGF5oSNbJkMeta } from "/var/www/2025-07-04_11_18/pages/wrapping/palletising.vue?macro=true";
import { default as fast_45delivery_45capital9X5_hK2XWUXS689j2PWV6EX2DQdyNbbWgaDtnX6extoMeta } from "/var/www/2025-07-04_11_18/pages/fast-delivery-capital.vue?macro=true";
import { default as _91guid_93rtJegzdrk0dOyu53S6PPM_45dDdOEpkajIRrPCiI0h9E8Meta } from "/var/www/2025-07-04_11_18/pages/personal/order/[guid].vue?macro=true";
import { default as create2naEjp_45P3843rW3ZN_45bWK4HquIuN0twu4m_45TSJovygcMeta } from "/var/www/2025-07-04_11_18/pages/personal/order/create.vue?macro=true";
import { default as barrels6Vh_45OS73j_45DSpVyEcUlvKi1sVDOYQXNowHkL8T2H7AUMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/barrels.vue?macro=true";
import { default as clothesbi9AZfjyzhch4YsgX6b6laSiofFQsEMgXjbuSiUHIboMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/clothes.vue?macro=true";
import { default as fragileW_QnDznsRiU6sHwVGP4avm9_45VP8AEFhbsiNuTIt_45i98Meta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/fragile.vue?macro=true";
import { default as trailerDSH6i4vGPJ_oNxpF5Mw1XF69qcL33bIag2TT9_yxZLYMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/trailer.vue?macro=true";
import { default as safe_45packageW6vroB_a76JCjnqVgCTkuSmJUBpMrqJwB0sIj1f5yJEMeta } from "/var/www/2025-07-04_11_18/pages/wrapping/safe-package.vue?macro=true";
import { default as bepaid_45success8ieUAy5UB4kupTCRR789Jn_45JfPfP7MitS7MomVzyHIkMeta } from "/var/www/2025-07-04_11_18/pages/payment/bepaid-success.vue?macro=true";
import { default as extra_45packagehLbnKcgsg4wolGOae2OFFbC3k1UWtKPAWjlvjU1DhtwMeta } from "/var/www/2025-07-04_11_18/pages/wrapping/extra-package.vue?macro=true";
import { default as wildberriesVAhVxOm3SiF_HfCjpBCN5AgVgsRxF_45sowJ5rdA_v_XcMeta } from "/var/www/2025-07-04_11_18/pages/marketplace/wildberries.vue?macro=true";
import { default as _91guid_93gn2UxqrB_Pp3rRYdv_45YiDDgJ3nh_0_0axSHNrNa_c9gMeta } from "/var/www/2025-07-04_11_18/pages/order/administer/[guid].vue?macro=true";
import { default as furnituregAgVIOBPm4tDzyfE_45PnHe8PXX3jxFCQsHTcmnPP23qQMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/furniture.vue?macro=true";
import { default as oversizedEZgiXHOeS6bi1w607_45gEugjoIDTOrR37gbXqZ435vV8Meta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/oversized.vue?macro=true";
import { default as quad_45biket3ohAQaVrHAXHrm24FuwISsY9a6qLLyeojInbwQTWOwMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/quad-bike.vue?macro=true";
import { default as _91locations_93RdajP0VRixSPfLndVbhOvmWaxq2rTk_e6opKZKjclS0Meta } from "/var/www/2025-07-04_11_18/pages/order/create/[locations].vue?macro=true";
import { default as _91_46_46_46tab_93Bbdn_45a41i4CsXFGWPF3aYyCqnd2we3JZ8FulOviPQoMMeta } from "/var/www/2025-07-04_11_18/pages/personal/orders/[...tab].vue?macro=true";
import { default as auto_45partsOK9YBK_hIaFf8Q5g0kb2uB9A_45_ZZQjSi_45WiwS1caYj4Meta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/auto-parts.vue?macro=true";
import { default as newspapersmqJNzpl7oCBkpH_45S1QJ9svmA9pz2pfwzK93T0A4h2_45EMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/newspapers.vue?macro=true";
import { default as smallcargoYdWf80cy1g3rOpcda_wOqUJ6cVdBwlGWjT8EASB7LSAMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/smallcargo.vue?macro=true";
import { default as snowmobilenmcUtCIkJZ9icGQibUer_45cOeDGNhhuTAXH_yOvHO8cAMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/snowmobile.vue?macro=true";
import { default as indexRt3KWWPEkBtdBzHp5JilfkvfJ7pOnGVq1iy_Q1Fv2UkMeta } from "/var/www/2025-07-04_11_18/pages/iframe/order/create/index.vue?macro=true";
import { default as yandex_45marketBjuhXtqQV_8b8My1cJ34j0Ln6_q_4537gdLVnGlno_i3YMeta } from "/var/www/2025-07-04_11_18/pages/marketplace/yandex-market.vue?macro=true";
import { default as templatesLLgzPrGR_VG_zMcy8_G3Oa_KWLqPIWHiKPUVLrxBu8MMeta } from "/var/www/2025-07-04_11_18/pages/personal/orders/templates.vue?macro=true";
import { default as index_OkTieAcb9aGPfv03bz3rO4D_45V3ukMNwe1w3YJX6awoMeta } from "/var/www/2025-07-04_11_18/pages/personal/contractors/index.vue?macro=true";
import { default as refrigeratorSbdTvW9XcBupaTcqhNW0AXBFTiF2ADPLGtBDGa4yWNoMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/refrigerator.vue?macro=true";
import { default as _91guid_9300fOqs369rOJ3trMSFT2dOlWJcPNEKtPdtp8mbvzGdUMeta } from "/var/www/2025-07-04_11_18/pages/personal/contractors/[guid].vue?macro=true";
import { default as indexC9avEi0hPuZPGqhwFkIrkFrDrq2j41TCDnqwTZgg3pEMeta } from "/var/www/2025-07-04_11_18/pages/personal/multi-pickup/index.vue?macro=true";
import { default as _91guid_93rtEbEfN9YQvbl1PUJX1Xet_9WE8FZx_B9n3Qn8jkGKQMeta } from "/var/www/2025-07-04_11_18/pages/personal/multi-pickup/[guid].vue?macro=true";
import { default as consumer_45goodsPxdiLanrABp0UW1LIN5g01aG0flkSqJCv9IzU1TvW0MMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/consumer-goods.vue?macro=true";
import { default as indexONzgb3st7EvlKhVJ84xUwiO9fBl4m7cQIxgbAYT6Li8Meta } from "/var/www/2025-07-04_11_18/pages/personal/group-printing/index.vue?macro=true";
import { default as indexZrT3zXHZ1YZwTku4zPxTZ21LiPmBpkdJUOBy_g4PalUMeta } from "/var/www/2025-07-04_11_18/pages/personal/multi-delivery/index.vue?macro=true";
import { default as medical_45devicesP3lIedKY_45Ktf_Ex76mP6yYtPEGPr0gsyEKsFp8RSo20Meta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/medical-devices.vue?macro=true";
import { default as _91guid_93IknW7Hb7A2NjEsE5aMG7l3NjzVH5rZERObm_Pu2NausMeta } from "/var/www/2025-07-04_11_18/pages/iframe/order/administer/[guid].vue?macro=true";
import { default as _91guid_93nbAUh2ZhJhFwsO642j5_cBmG7mCU5frgthAnOXyEThYMeta } from "/var/www/2025-07-04_11_18/pages/personal/multi-delivery/[guid].vue?macro=true";
import { default as _91_46_46_46id_93lSy7VJK6FkeiC__45hBv1S3VZIM4H1UmICkb0jspANiX4Meta } from "/var/www/2025-07-04_11_18/pages/personal/order/template/[...id].vue?macro=true";
import { default as special_45equipment_N2eWxzeRVDZewMUGbFgXBQC97gWFE_pJD_45Z2161rR0Meta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/special-equipment.vue?macro=true";
import { default as building_45materialsgsTi_45YIgRkEigJw_bDNzm_ZeGIz1bJkz6uMXtAmV3usMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/building-materials.vue?macro=true";
import { default as musical_45instrumentsyUZUuY6Mg_sPo8AowYKuj99lkYdUyfiOmhJ4a841hqUMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/musical-instruments.vue?macro=true";
import { default as industrial_45equipment7J8SkHovYkiLEyuCeuq8fSttUV9qT1HcesjsF_3kmtgMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/industrial-equipment.vue?macro=true";
import { default as motorcycletransportationeSliHuuepz7E1OpgMs9W0vVGNmvClQVWLwEXfL5fkUUMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/motorcycletransportation.vue?macro=true";
import { default as _91locationFrom_93__91locationTo_93dmKfJath0kc2r7wu8o4_457y5pvP9xGBB9Idr9DW6WKf4Meta } from "/var/www/2025-07-04_11_18/pages/order/create/[locationFrom]_[locationTo].vue?macro=true";
import { default as personalitemstransportationL_0JjrkykjJEd12gMy0RYHQzN7fss4kZUwK08oOSuhYMeta } from "/var/www/2025-07-04_11_18/pages/shippingtypes/personalitemstransportation.vue?macro=true";
export default [
  {
    name: "edo",
    path: "/edo",
    component: () => import("/var/www/2025-07-04_11_18/pages/edo.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/var/www/2025-07-04_11_18/pages/help.vue")
  },
  {
    name: "cargo",
    path: "/cargo",
    component: () => import("/var/www/2025-07-04_11_18/pages/cargo.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/2025-07-04_11_18/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    meta: _91slug_93AoYh9lsPdGppoQwMgCvnRDp06nHz9_sKNBM4oBYR2ZoMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/[slug].vue")
  },
  {
    name: "cookie",
    path: "/cookie",
    component: () => import("/var/www/2025-07-04_11_18/pages/cookie.vue")
  },
  {
    name: "belarus",
    path: "/belarus",
    component: () => import("/var/www/2025-07-04_11_18/pages/belarus.vue")
  },
  {
    name: "bonuses",
    path: "/bonuses",
    component: () => import("/var/www/2025-07-04_11_18/pages/bonuses.vue")
  },
  {
    name: "dev-api",
    path: "/dev/api",
    component: () => import("/var/www/2025-07-04_11_18/pages/dev/api.vue")
  },
  {
    name: "dev-cms",
    path: "/dev/cms",
    component: () => import("/var/www/2025-07-04_11_18/pages/dev/cms.vue")
  },
  {
    name: "konkurs",
    path: "/konkurs",
    meta: konkurszOd3odgLQ65g_45JP0_45xbaqtz2nMhFh2haq5pxdtw_45aNQMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/konkurs.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/var/www/2025-07-04_11_18/pages/success.vue")
  },
  {
    name: "tariffs",
    path: "/tariffs",
    component: () => import("/var/www/2025-07-04_11_18/pages/tariffs.vue")
  },
  {
    name: "vacancy",
    path: "/vacancy",
    component: () => import("/var/www/2025-07-04_11_18/pages/vacancy.vue")
  },
  {
    name: "contacts",
    path: "/:tag(address|contacts)/:location?",
    meta: contactsAD69pACvfa3ixXcBSQcJMhaK_pWRgWmF6jQfGwkZwokMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/contacts.vue")
  },
  {
    name: "giveaway",
    path: "/giveaway",
    component: () => import("/var/www/2025-07-04_11_18/pages/giveaway.vue")
  },
  {
    name: "guide-lk",
    path: "/guide-lk",
    component: () => import("/var/www/2025-07-04_11_18/pages/guide-lk.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/var/www/2025-07-04_11_18/pages/services.vue")
  },
  {
    name: "telegram",
    path: "/telegram",
    component: () => import("/var/www/2025-07-04_11_18/pages/telegram.vue")
  },
  {
    name: "documents",
    path: "/documents",
    component: () => import("/var/www/2025-07-04_11_18/pages/documents.vue")
  },
  {
    name: "franchise",
    path: "/franchise",
    component: () => import("/var/www/2025-07-04_11_18/pages/franchise.vue")
  },
  {
    name: "insurance",
    path: "/insurance",
    component: () => import("/var/www/2025-07-04_11_18/pages/insurance.vue")
  },
  {
    name: "kirghizia",
    path: "/kirghizia",
    component: () => import("/var/www/2025-07-04_11_18/pages/kirghizia.vue")
  },
  {
    name: "mapScheme",
    path: "/mapScheme",
    meta: mapSchemeVTMru_45HkqZcHmD0WR946vRVwtdEdQ6piQtkaT9QMbuAMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/mapScheme.vue")
  },
  {
    name: "news-id",
    path: "/:tag(news|actions)/:id",
    meta: _91id_93D1ZqaHOub_45UwoLaKQargltyqDsJEQ6oc3ER2OJnafscMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/news/[id].vue")
  },
  {
    name: "return-sd",
    path: "/return-sd",
    component: () => import("/var/www/2025-07-04_11_18/pages/return-sd.vue")
  },
  {
    name: "smsClient",
    path: "/smsClient",
    component: () => import("/var/www/2025-07-04_11_18/pages/smsClient.vue")
  },
  {
    name: "terminals",
    path: "/terminals",
    component: () => import("/var/www/2025-07-04_11_18/pages/terminals.vue")
  },
  {
    name: "dev-iframe",
    path: "/dev/iframe",
    component: () => import("/var/www/2025-07-04_11_18/pages/dev/iframe.vue")
  },
  {
    name: "directions",
    path: "/directions",
    component: () => import("/var/www/2025-07-04_11_18/pages/directions.vue")
  },
  {
    name: "kazakhstan",
    path: "/kazakhstan",
    component: () => import("/var/www/2025-07-04_11_18/pages/kazakhstan.vue")
  },
  {
    name: "news",
    path: "/:tag(news|actions)",
    meta: index_mDnGqAQKWHIVySJBnJKFmnRrnQAfgqYCHTdYiCm8SsMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/news/index.vue")
  },
  {
    name: "ui-kit-svg",
    path: "/ui-kit/svg",
    component: () => import("/var/www/2025-07-04_11_18/pages/ui-kit/svg.vue")
  },
  {
    name: "vzpay-fail",
    path: "/vzpay-fail",
    component: () => import("/var/www/2025-07-04_11_18/pages/vzpay-fail.vue")
  },
  {
    name: "constructor",
    path: "/constructor",
    meta: constructor8Cy0YaeSVuKQJaiMEBnVZ9XJS31IrXwh3TaviwgomPkMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/constructor.vue")
  },
  {
    name: "gifts",
    path: "/gifts",
    meta: indexx4c68VTtWN_H3hNr07__45DDHu5tnSx5ZnEZRdVbfYMzAMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/gifts/index.vue")
  },
  {
    name: "information",
    path: "/information",
    component: () => import("/var/www/2025-07-04_11_18/pages/information.vue")
  },
  {
    name: "order-light",
    path: "/order/light",
    component: () => import("/var/www/2025-07-04_11_18/pages/order/light.vue")
  },
  {
    name: "claim-filing",
    path: "/claim-filing",
    component: () => import("/var/www/2025-07-04_11_18/pages/claim-filing.vue")
  },
  {
    name: "gifts-type",
    path: "/gift/:type(m|o)",
    meta: _91type_935k6Ui9eX2e3WIAGD8UAFe1GFtw2zeDI52V39feW0PJIMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/gifts/[type].vue")
  },
  {
    name: "marketplaces",
    path: "/marketplaces",
    component: () => import("/var/www/2025-07-04_11_18/pages/marketplaces.vue")
  },
  {
    name: "networkshops",
    path: "/networkshops",
    component: () => import("/var/www/2025-07-04_11_18/pages/networkshops.vue")
  },
  {
    name: "online-store",
    path: "/online-store",
    component: () => import("/var/www/2025-07-04_11_18/pages/online-store.vue")
  },
  {
    name: "order-manage",
    path: "/order/manage",
    component: () => import("/var/www/2025-07-04_11_18/pages/order/manage.vue")
  },
  {
    name: "registration",
    path: "/registration",
    component: () => import("/var/www/2025-07-04_11_18/pages/registration.vue")
  },
  {
    name: "run-schedule",
    path: "/run-schedule",
    component: () => import("/var/www/2025-07-04_11_18/pages/run-schedule.vue")
  },
  {
    name: "safe-custody",
    path: "/safe-custody",
    component: () => import("/var/www/2025-07-04_11_18/pages/safe-custody.vue")
  },
  {
    name: "ui-kit-image",
    path: "/ui-kit/image",
    component: () => import("/var/www/2025-07-04_11_18/pages/ui-kit/image.vue")
  },
  {
    name: "ui-kit",
    path: "/ui-kit",
    component: () => import("/var/www/2025-07-04_11_18/pages/ui-kit/index.vue")
  },
  {
    name: "wrapping-bag",
    path: "/wrapping/bag",
    component: () => import("/var/www/2025-07-04_11_18/pages/wrapping/bag.vue")
  },
  {
    name: "wrapping-box",
    path: "/wrapping/box",
    component: () => import("/var/www/2025-07-04_11_18/pages/wrapping/box.vue")
  },
  {
    name: "cargo-loading",
    path: "/cargo-loading",
    component: () => import("/var/www/2025-07-04_11_18/pages/cargo-loading.vue")
  },
  {
    name: "happybirthday",
    path: "/happybirthday",
    meta: happybirthdayMkishkQSAxRBMYoINdqrSPhA8pbeeX0ECThsi2nyVt4Meta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/happybirthday.vue")
  },
  {
    name: "iframe-manage",
    path: "/iframe/manage",
    meta: managerLtKngmlYmYWbt6gMbFSRc7hUJpSCGGQU20nSk4aIhwMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/iframe/manage.vue")
  },
  {
    name: "personal-auth",
    path: "/personal/auth",
    component: () => import("/var/www/2025-07-04_11_18/pages/personal/auth.vue")
  },
  {
    name: "ui-kit-public",
    path: "/ui-kit/public",
    component: () => import("/var/www/2025-07-04_11_18/pages/ui-kit/public.vue")
  },
  {
    name: "already-answer",
    path: "/already-answer",
    component: () => import("/var/www/2025-07-04_11_18/pages/already-answer.vue")
  },
  {
    name: "iframe-tariffs",
    path: "/iframe/tariffs",
    meta: tariffsRouqlfiK8_vCO0cPI4AD66KLIb8TXJ3_o0Lcjexum0wMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/iframe/tariffs.vue")
  },
  {
    name: "order-pay-id",
    path: "/order/pay/:id()",
    component: () => import("/var/www/2025-07-04_11_18/pages/order/pay/[id].vue")
  },
  {
    name: "personal",
    path: "/personal",
    meta: indexiJwQ9I393hy8OCCGlfbj7IXJcMcWP1K1n77l16mJ8iQMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/personal/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/var/www/2025-07-04_11_18/pages/privacy-policy.vue")
  },
  {
    name: "welcome-hash",
    path: "/welcome/:hash()",
    component: () => import("/var/www/2025-07-04_11_18/pages/welcome/[hash].vue")
  },
  {
    name: "wrapping",
    path: "/wrapping",
    component: () => import("/var/www/2025-07-04_11_18/pages/wrapping/index.vue")
  },
  {
    name: "delivery-russia",
    path: "/delivery-russia",
    component: () => import("/var/www/2025-07-04_11_18/pages/delivery-russia.vue")
  },
  {
    name: "payment-methods",
    path: "/payment-methods",
    component: () => import("/var/www/2025-07-04_11_18/pages/payment-methods.vue")
  },
  {
    name: "payment-qr-info",
    path: "/payment/qr-info",
    component: () => import("/var/www/2025-07-04_11_18/pages/payment/qr-info.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    component: () => import("/var/www/2025-07-04_11_18/pages/payment/success.vue")
  },
  {
    name: "personal-import",
    path: "/personal/import",
    meta: importgIBBy2mPn7Yu9lC1tvCShJWv4MzvgMPu0ZrHoVOeRGEMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/personal/import.vue")
  },
  {
    name: "personal-logout",
    path: "/personal/logout",
    meta: logoutHVj7CD2qmw_450xvgnLGFkV1avXdR0PgmAXQKSbBrfq1MMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/personal/logout.vue")
  },
  {
    name: "address-delivery",
    path: "/address-delivery",
    component: () => import("/var/www/2025-07-04_11_18/pages/address-delivery.vue")
  },
  {
    name: "cash-on-delivery",
    path: "/cash-on-delivery",
    component: () => import("/var/www/2025-07-04_11_18/pages/cash-on-delivery.vue")
  },
  {
    name: "happynewyear2024",
    path: "/happynewyear2024",
    meta: happynewyear2024PSbbmhytlyP58D7Hp4HdBeIm0bj8EKFSCB5LOIf9d_45YMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/happynewyear2024.vue")
  },
  {
    name: "marketplace-ozon",
    path: "/ozon",
    meta: ozonNAVyvRDtYdcU07_45kavpy5fWILxysDyfhw3FOi9EMqZkMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/marketplace/ozon.vue")
  },
  {
    name: "payment-pay-fail",
    path: "/payment/pay-fail",
    component: () => import("/var/www/2025-07-04_11_18/pages/payment/pay-fail.vue")
  },
  {
    name: "personal-account",
    path: "/personal/account",
    meta: account2Sic2ZEAVHB9hIJfGZVuFks0_45bPB_qpl5pB_45im4emRoMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/personal/account.vue")
  },
  {
    name: "prohibited-goods",
    path: "/prohibited-goods",
    component: () => import("/var/www/2025-07-04_11_18/pages/prohibited-goods.vue")
  },
  {
    name: "ui-kit-direction",
    path: "/ui-kit/direction",
    component: () => import("/var/www/2025-07-04_11_18/pages/ui-kit/direction.vue")
  },
  {
    name: "free-group-pickup",
    path: "/free-group-pickup",
    component: () => import("/var/www/2025-07-04_11_18/pages/free-group-pickup.vue")
  },
  {
    name: "free-pickup-cargo",
    path: "/free-pickup-cargo",
    component: () => import("/var/www/2025-07-04_11_18/pages/free-pickup-cargo.vue")
  },
  {
    name: "iframe-calculator",
    path: "/iframe/calculator",
    meta: calculator8VKHzbYVDymSWqwglOI9b53BvEf16MVV_bbqf2WrxYwMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/iframe/calculator.vue")
  },
  {
    name: "merch-for-bonuses",
    path: "/merch-for-bonuses",
    component: () => import("/var/www/2025-07-04_11_18/pages/merch-for-bonuses.vue")
  },
  {
    name: "order-pay-qr-id",
    path: "/order/pay/qr/:id()",
    component: () => import("/var/www/2025-07-04_11_18/pages/order/pay/qr/[id].vue")
  },
  {
    name: "payment-card-info",
    path: "/payment/card-info",
    component: () => import("/var/www/2025-07-04_11_18/pages/payment/card-info.vue")
  },
  {
    name: "personal-discount",
    path: "/personal/discount",
    meta: discount4E1KFWeUUB3HQwv33WPKjja_n0mRVOKiIohv4f_45GBWsMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/personal/discount.vue")
  },
  {
    name: "wrapping-hard-box",
    path: "/wrapping/hard-box",
    component: () => import("/var/www/2025-07-04_11_18/pages/wrapping/hard-box.vue")
  },
  {
    name: "forwarding-receipt",
    path: "/forwarding-receipt",
    component: () => import("/var/www/2025-07-04_11_18/pages/forwarding-receipt.vue")
  },
  {
    name: "mailClient10201917",
    path: "/mailClient10201917",
    meta: mailClient10201917eNU9ctzojrk7s_VhhD4xdMerMiZiqkssXsbp5tInxc0Meta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/mailClient10201917.vue")
  },
  {
    name: "mobile-application",
    path: "/mobile-application",
    component: () => import("/var/www/2025-07-04_11_18/pages/mobile-application.vue")
  },
  {
    name: "order-create",
    path: "/order/create",
    meta: index9kdZBWI7oHp_45VFGbY4HL592u_qbCS_452XpmyRKekQhyUMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/order/create/index.vue")
  },
  {
    name: "shippingtypes-boat",
    path: "/shippingtypes/boat",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/boat.vue")
  },
  {
    name: "shippingtypes-sofa",
    path: "/shippingtypes/sofa",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/sofa.vue")
  },
  {
    name: "wrapping-cardboard",
    path: "/wrapping/cardboard",
    component: () => import("/var/www/2025-07-04_11_18/pages/wrapping/cardboard.vue")
  },
  {
    name: "personal-promocodes",
    path: "/personal/promocodes",
    meta: promocodes9hLOBQ4Jd0sCdXLZM7E0q_45FWjRo8_ksxwl_45Dib4c6YkMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/personal/promocodes.vue")
  },
  {
    name: "shippingtypes-bench",
    path: "/shippingtypes/bench",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/bench.vue")
  },
  {
    name: "shippingtypes-books",
    path: "/shippingtypes/books",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/books.vue")
  },
  {
    name: "shippingtypes-cable",
    path: "/shippingtypes/cable",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/cable.vue")
  },
  {
    name: "shippingtypes-chair",
    path: "/shippingtypes/chair",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/chair.vue")
  },
  {
    name: "shippingtypes-goods",
    path: "/shippingtypes/goods",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/goods.vue")
  },
  {
    name: "shippingtypes",
    path: "/shippingtypes",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/index.vue")
  },
  {
    name: "shippingtypes-metal",
    path: "/shippingtypes/metal",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/metal.vue")
  },
  {
    name: "shippingtypes-piano",
    path: "/shippingtypes/piano",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/piano.vue")
  },
  {
    name: "shippingtypes-pipes",
    path: "/shippingtypes/pipes",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/pipes.vue")
  },
  {
    name: "shippingtypes-tools",
    path: "/shippingtypes/tools",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/tools.vue")
  },
  {
    name: "wrapping-pallet-box",
    path: "/wrapping/pallet-box",
    component: () => import("/var/www/2025-07-04_11_18/pages/wrapping/pallet-box.vue")
  },
  {
    name: "personal-bonus-tab",
    path: "/personal/bonus/:tab()",
    meta: _91tab_93DBu4jqzATTbQlX18sLmJ0K9UZp_vdQ0roRbl35q6O5EMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/personal/bonus/[tab].vue")
  },
  {
    name: "personal-order-print",
    path: "/personal/order/print",
    meta: printw7wz23l0ejBSovoV3KnfHDLYVFLzieoueWP_45yxqIdTQMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/personal/order/print.vue")
  },
  {
    name: "shippingtypes-dishes",
    path: "/shippingtypes/dishes",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/dishes.vue")
  },
  {
    name: "shippingtypes-engine",
    path: "/shippingtypes/engine",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/engine.vue")
  },
  {
    name: "shippingtypes-lumber",
    path: "/shippingtypes/lumber",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/lumber.vue")
  },
  {
    name: "shippingtypes-wheels",
    path: "/shippingtypes/wheels",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/wheels.vue")
  },
  {
    name: "wrapping-bubble-film",
    path: "/wrapping/bubble-film",
    component: () => import("/var/www/2025-07-04_11_18/pages/wrapping/bubble-film.vue")
  },
  {
    name: "wrapping-palletising",
    path: "/wrapping/palletising",
    component: () => import("/var/www/2025-07-04_11_18/pages/wrapping/palletising.vue")
  },
  {
    name: "fast-delivery-capital",
    path: "/fast-delivery-capital",
    component: () => import("/var/www/2025-07-04_11_18/pages/fast-delivery-capital.vue")
  },
  {
    name: "personal-order-guid",
    path: "/personal/order/:tag(pay)?/:guid",
    meta: _91guid_93rtJegzdrk0dOyu53S6PPM_45dDdOEpkajIRrPCiI0h9E8Meta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/personal/order/[guid].vue")
  },
  {
    name: "personal-order-create",
    path: "/personal/order/create",
    meta: create2naEjp_45P3843rW3ZN_45bWK4HquIuN0twu4m_45TSJovygcMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/personal/order/create.vue")
  },
  {
    name: "shippingtypes-barrels",
    path: "/shippingtypes/barrels",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/barrels.vue")
  },
  {
    name: "shippingtypes-clothes",
    path: "/shippingtypes/clothes",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/clothes.vue")
  },
  {
    name: "shippingtypes-fragile",
    path: "/shippingtypes/fragile",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/fragile.vue")
  },
  {
    name: "shippingtypes-trailer",
    path: "/shippingtypes/trailer",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/trailer.vue")
  },
  {
    name: "wrapping-safe-package",
    path: "/wrapping/safe-package",
    component: () => import("/var/www/2025-07-04_11_18/pages/wrapping/safe-package.vue")
  },
  {
    name: "payment-bepaid-success",
    path: "/payment/bepaid-success",
    component: () => import("/var/www/2025-07-04_11_18/pages/payment/bepaid-success.vue")
  },
  {
    name: "wrapping-extra-package",
    path: "/wrapping/extra-package",
    component: () => import("/var/www/2025-07-04_11_18/pages/wrapping/extra-package.vue")
  },
  {
    name: "marketplace-wildberries",
    path: "/wildberries",
    meta: wildberriesVAhVxOm3SiF_HfCjpBCN5AgVgsRxF_45sowJ5rdA_v_XcMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/marketplace/wildberries.vue")
  },
  {
    name: "order-administer-guid",
    path: "/order/administer/:guid()",
    component: () => import("/var/www/2025-07-04_11_18/pages/order/administer/[guid].vue")
  },
  {
    name: "shippingtypes-furniture",
    path: "/shippingtypes/furniture",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/furniture.vue")
  },
  {
    name: "shippingtypes-oversized",
    path: "/shippingtypes/oversized",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/oversized.vue")
  },
  {
    name: "shippingtypes-quad-bike",
    path: "/shippingtypes/quad-bike",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/quad-bike.vue")
  },
  {
    name: "order-create-locations",
    path: "/order/create/:locations()",
    component: () => import("/var/www/2025-07-04_11_18/pages/order/create/[locations].vue")
  },
  {
    name: "personal-orders-tab",
    path: "/personal/orders/:tab(.*)*",
    meta: _91_46_46_46tab_93Bbdn_45a41i4CsXFGWPF3aYyCqnd2we3JZ8FulOviPQoMMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/personal/orders/[...tab].vue")
  },
  {
    name: "shippingtypes-auto-parts",
    path: "/shippingtypes/auto-parts",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/auto-parts.vue")
  },
  {
    name: "shippingtypes-newspapers",
    path: "/shippingtypes/newspapers",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/newspapers.vue")
  },
  {
    name: "shippingtypes-smallcargo",
    path: "/shippingtypes/smallcargo",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/smallcargo.vue")
  },
  {
    name: "shippingtypes-snowmobile",
    path: "/shippingtypes/snowmobile",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/snowmobile.vue")
  },
  {
    name: "iframe-order-create",
    path: "/iframe/order/create",
    meta: indexRt3KWWPEkBtdBzHp5JilfkvfJ7pOnGVq1iy_Q1Fv2UkMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/iframe/order/create/index.vue")
  },
  {
    name: "marketplace-yandex-market",
    path: "/yandex-market",
    meta: yandex_45marketBjuhXtqQV_8b8My1cJ34j0Ln6_q_4537gdLVnGlno_i3YMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/marketplace/yandex-market.vue")
  },
  {
    name: "personal-orders-templates",
    path: "/personal/orders/templates",
    meta: templatesLLgzPrGR_VG_zMcy8_G3Oa_KWLqPIWHiKPUVLrxBu8MMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/personal/orders/templates.vue")
  },
  {
    name: "personal-contractors",
    path: "/personal/contractors",
    meta: index_OkTieAcb9aGPfv03bz3rO4D_45V3ukMNwe1w3YJX6awoMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/personal/contractors/index.vue")
  },
  {
    name: "shippingtypes-refrigerator",
    path: "/shippingtypes/refrigerator",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/refrigerator.vue")
  },
  {
    name: "personal-contractors-guid",
    path: "/personal/contractors/:guid()",
    meta: _91guid_9300fOqs369rOJ3trMSFT2dOlWJcPNEKtPdtp8mbvzGdUMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/personal/contractors/[guid].vue")
  },
  {
    name: "personal-multi-pickup",
    path: "/personal/multi-pickup",
    meta: indexC9avEi0hPuZPGqhwFkIrkFrDrq2j41TCDnqwTZgg3pEMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/personal/multi-pickup/index.vue")
  },
  {
    name: "personal-multi-pickup-guid",
    path: "/personal/multi-pickup/:guid",
    meta: _91guid_93rtEbEfN9YQvbl1PUJX1Xet_9WE8FZx_B9n3Qn8jkGKQMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/personal/multi-pickup/[guid].vue")
  },
  {
    name: "shippingtypes-consumer-goods",
    path: "/shippingtypes/consumer-goods",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/consumer-goods.vue")
  },
  {
    name: "personal-group-printing",
    path: "/personal/group-printing",
    meta: indexONzgb3st7EvlKhVJ84xUwiO9fBl4m7cQIxgbAYT6Li8Meta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/personal/group-printing/index.vue")
  },
  {
    name: "personal-multi-delivery",
    path: "/personal/multi-delivery",
    meta: indexZrT3zXHZ1YZwTku4zPxTZ21LiPmBpkdJUOBy_g4PalUMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/personal/multi-delivery/index.vue")
  },
  {
    name: "shippingtypes-medical-devices",
    path: "/shippingtypes/medical-devices",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/medical-devices.vue")
  },
  {
    name: "iframe-order-administer-guid",
    path: "/iframe/order/administer/:guid()",
    meta: _91guid_93IknW7Hb7A2NjEsE5aMG7l3NjzVH5rZERObm_Pu2NausMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/iframe/order/administer/[guid].vue")
  },
  {
    name: "personal-multi-delivery-guid",
    path: "/personal/multi-delivery/:guid",
    meta: _91guid_93nbAUh2ZhJhFwsO642j5_cBmG7mCU5frgthAnOXyEThYMeta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/personal/multi-delivery/[guid].vue")
  },
  {
    name: "personal-order-template-id",
    path: "/personal/order/template/:id(.*)*",
    meta: _91_46_46_46id_93lSy7VJK6FkeiC__45hBv1S3VZIM4H1UmICkb0jspANiX4Meta || {},
    component: () => import("/var/www/2025-07-04_11_18/pages/personal/order/template/[...id].vue")
  },
  {
    name: "shippingtypes-special-equipment",
    path: "/shippingtypes/special-equipment",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/special-equipment.vue")
  },
  {
    name: "shippingtypes-building-materials",
    path: "/shippingtypes/building-materials",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/building-materials.vue")
  },
  {
    name: "shippingtypes-musical-instruments",
    path: "/shippingtypes/musical-instruments",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/musical-instruments.vue")
  },
  {
    name: "shippingtypes-industrial-equipment",
    path: "/shippingtypes/industrial-equipment",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/industrial-equipment.vue")
  },
  {
    name: "shippingtypes-motorcycletransportation",
    path: "/shippingtypes/motorcycletransportation",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/motorcycletransportation.vue")
  },
  {
    name: "order-create-locationFrom_locationTo",
    path: "/order/create/:locationFrom()_:locationTo()",
    component: () => import("/var/www/2025-07-04_11_18/pages/order/create/[locationFrom]_[locationTo].vue")
  },
  {
    name: "shippingtypes-personalitemstransportation",
    path: "/shippingtypes/personalitemstransportation",
    component: () => import("/var/www/2025-07-04_11_18/pages/shippingtypes/personalitemstransportation.vue")
  }
]